<div class="page-container">

    <app-topbar></app-topbar>

    @if (showSidebar) {
        <app-sidebar></app-sidebar>
    }

    <div class="content-container" [class.full-width]="!showSidebar">
        <router-outlet></router-outlet>
    </div>

</div>